import { DateISO8601, defaultDateISO8601 } from 'models/utils'

type HistoryDTO = {
  _id: string
  vehicleNo: string
  licensePlate: string
  userId: string
  updateDateTime: DateISO8601
  reservePriceAfter: number
  reservePriceBefore: number
  userDetails: string
  // name: string
  // email: string
  userIp: string
  entityId: string
}

type HistoryCreateBody = Omit<HistoryDTO, '_id'>

const defaultHistoryDTO: HistoryDTO = {
  _id: '',
  vehicleNo: '',
  licensePlate: '',
  userId: '',
  updateDateTime: defaultDateISO8601,
  reservePriceAfter: 0,
  reservePriceBefore: 0,
  userDetails: '',
  // name: '',
  // email: '',
  userIp: '',
  entityId: '',
}

const dummyHistoryResponse: Array<HistoryDTO> = [
  {
    _id: '',
    vehicleNo: 'DummyNO',
    licensePlate: 'XX888ZZ',
    userId: 'dumyUserId',
    updateDateTime: defaultDateISO8601,
    reservePriceBefore: 0,
    reservePriceAfter: 10,
    userDetails: 'details',
    // name: 'Dummy Name',
    // email: 'dummy@email.com',
    userIp: 'dummyIPaddress',
    entityId: '',
  },
]

export type { HistoryDTO, HistoryCreateBody }
export { dummyHistoryResponse, defaultHistoryDTO }
